import React, { useEffect , useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import uuid from "uuid/v1";
import easypayLogo from "~/pages/Easypay/assets/img/logos/easypay-logotipo.png";
import unikLogo from "~/assets/img/logos/unik-logo.png";
import "~/pages/Easypay/assets/css/styles.css";
import Header from "~/pages/Easypay/components/Header";
import "~/pages/Easypay/assets/scss/_backofficeEasypayLeadsPage.scss";
import BackOfficeBenefSection from "~/pages/Easypay/components/BackOfficeBenefSection.js";
import BackOfficeClientSection from "~/pages/Easypay/components/BackOfficeClientSection.js";
import BackOfficeDocumentsSection from "~/pages/Easypay/components/BackOfficeDocumentsSection.js";
import BackOfficeEasypaySubHeader from "~/pages/Easypay/components/BackOfficeEasypaySubHeader.js";
import BackOfficeRepLegSection from "~/pages/Easypay/components/BackOfficeRepLegSection.js";
import BackOfficeVerticalButtons from "~/pages/Easypay/components/BackOfficeVerticalButtons.js";
import BackOfficeSignaturesSection from "~/pages/Easypay/components/BackOfficeSignaturesSection.js";
import Button from "~/pages/Easypay/components/Button.js";
import LineBreak from "~/pages/Easypay/components/LineBreak.js";
import { withRouter, useLocation } from "react-router-dom";
import Modal from "~/pages/Easypay/components/Modal";
import ProvaDeVida from "~/pages/Easypay/components/ProvaDeVida";

import {
  getUser,
  updateUser,
  setTriggerLoading,
} from "~/store/ducks/onboarding/actionTypes";

const IndividualOnboarding = (props) => {
  const [doneSave, setDoneSave] = useState(false);
  const [isModalShowing, setIsModalShowing] = useState(false);
  const [isModalErrorShowing, setIsModalErrorShowing] = useState(false);
  const [isModalSaveShowing, setIsModalSaveShowing] = useState(false);
  const { pid, application } = props.match?.params;
  const location = useLocation();
  var isFirstTime = true;

  useEffect(() => {
    if (isFirstTime) {
      if (
        location.prevPath?.includes("request-document") ||
        location.prevPath?.includes("document-preview")
      ) {
        handleClick("backoffice-1");
      }
      isFirstTime = false;
    }

    dispatch(getUser(pid));
  }, [triggerLoading]);

  useEffect(() => {
    if(doneSave)
    {
      setDoneSave(false)
      setIsModalSaveShowing(true)
    }
  }, [user,doneSave]);

  const { t } = props;

  const { user, triggerLoading } = useSelector(
    (state) => state.onboardingReducer
  );

  const dispatch = useDispatch();

  function createBody() {
    return (
      <div className="lift-modal-body-wrapper" style={{ minWidth: "400px" }}>
        <ProvaDeVida text="Conta aprovada" status="success" />
      </div>
    );
  }

  function createBodyError() {
    return (
      <div className="lift-modal-body-wrapper" style={{ minWidth: "400px" }}>
        <ProvaDeVida text="Conta Rejeitada" status="error" />
      </div>
    );
  }

  function createBodySave() {
    return (
      <div className="lift-modal-body-wrapper" style={{ minWidth: "400px" }}>
        <ProvaDeVida text="Alterações guardadas" status="success" />
      </div>
    );
  }

  const handleClick = (id) => {
    //Dynamic offSet that calculates header and subheader height
    const offSet =
      document?.getElementById("easypay-header")?.offsetHeight +
      document?.getElementById("easypay-backoffice-subheader")?.offsetHeight;
    const element = document.getElementById(id);
    const elementPosition = element?.offsetTop;
    const offsetPosition = elementPosition - offSet;

    document.documentElement.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
    //For Safari
    document.body.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  const handleSubmit = () => {
    user.account.modifiedDate = new Date();
    dispatch(updateUser({ user: user, pid: pid }));
    setDoneSave(true)
  };

  const buttonsList = [
    {
      name: "Cliente",
      text: t(`bpm.onboarding.backoffice.user.verticalTabClient`),
    },
    {
      name: "Documentos",
      text: t(`bpm.onboarding.backoffice.user.verticalTabDocuments`),
    },
    {
      name: "Representantes Legais",
      text: t(`bpm.onboarding.backoffice.user.verticalTabRepLeg`),
    },
    {
      name: "Beneficiários Efetivos",
      text: t(`bpm.onboarding.backoffice.user.verticalTabBenef`),
    },
    {
      name: "Assinaturas",
      text: t(`bpm.onboarding.backoffice.user.labelSignatures`),
    },
  ];

  const breadcrumbItems = [
    {
      text: "Onboarding",
      link: "uniksystem/onboarding/backoffic-organization/onboarding",
    },
    {
      text: user?.account?.pid,
      link: "uniksystem/onboarding/backoffic-organization/onboarding",
    },
  ];
  const addButtonField = {
    type: "link",
    text: "Trocar de conta::easypay-button-link",
    cssclass: "",
    onclick: "",
    onmouseover: "center",
    align: "right",
    href: "javascript:disableForm(false);document.dados.toggleCodigoCertidao.value='editRepLeg';document.dados.op.value='3';document.dados.submit();",
    newwindow: "false",
    newwindowname: "",
    disabled: "false",
    even_field: "true",
  };

  return (
    user && (
      <>
        <Header
          redirect={true}
          logo={
            !application
              ? ""
              : application?.applicationName === "easypay"
              ? easypayLogo
              : unikLogo
          }
          height={application?.applicationName === "easypay" ? "30px" : "40px"}
          exit={"#/uniksystem/onboarding/integrations"}
          hideExtraLinks={true}
          id={pid}
          addDocument={true}
        />
        <Modal
          className="easypay-modal"
          showModal={isModalShowing}
          setShowModal={setIsModalShowing}
          headerContent={"Aprovação de Cliente"}
          bodyContent={createBody()}
          key={uuid()}
        ></Modal>
        <Modal
          className="easypay-modal"
          showModal={isModalErrorShowing}
          setShowModal={setIsModalErrorShowing}
          headerContent={"Aprovação de Cliente"}
          bodyContent={createBodyError()}
          key={uuid()}
        ></Modal>
        <Modal
          className="easypay-modal"
          showModal={isModalSaveShowing}
          setShowModal={setIsModalSaveShowing}
          headerContent={"Guardar alterações"}
          bodyContent={createBodySave()}
          key={uuid()}
        ></Modal>
        <BackOfficeEasypaySubHeader
          breadcrumbItems={breadcrumbItems}
          data={user}
          pid={pid}
          setIsModalShowing = {setIsModalShowing}
          setIsModalErrorShowing = {setIsModalErrorShowing}
        />
        <BackOfficeVerticalButtons
          navItems={buttonsList}
          handleClick={handleClick}
        />
        <div className="easypay-backoffice-wrapper-leads">
          <div className="easypay-backoffice-leads-dummy-wrapper"></div>
          <div className="easypay-backoffice-leads-sub-wrapper">
            <div className="easypay-backoffice-leads-form-wrapper">
              <div div="easypay-backoffice-section-1" id="backoffice-0">
                <BackOfficeClientSection data={user} />
              </div>
              <div className="easypay-backoffice-line-break-wrapper">
                <LineBreak text="none" />
              </div>
              <div id="backoffice-1">
                <BackOfficeDocumentsSection id={pid} data={user} />
              </div>
              <div className="easypay-backoffice-line-break-wrapper">
                <LineBreak text="none" />
              </div>
              <div id="backoffice-2">
                <BackOfficeRepLegSection data={user} pid={pid} />
              </div>
              <div className="easypay-backoffice-line-break-wrapper">
                <LineBreak text="none" />
              </div>
              <div id="backoffice-3">
                <BackOfficeBenefSection data={user} pid={pid} />
              </div>
              <div className="easypay-backoffice-line-break-wrapper">
                <LineBreak text="none" />
              </div>
              <div id="backoffice-4">
                <BackOfficeSignaturesSection
                  data={user}
                  pid={pid}
                  user={user}
                />
              </div>
              <div className="easypay-backoffice-line-break-wrapper">
                <LineBreak text="none" />
              </div>
              <div className="easypay-backoffice-submit-button-wrapper">
                <Button
                  text={t(
                    "bpm.onboarding.backoffice.administration.saveChangesButton"
                  )}
                  variant={"easypay-button-primary"}
                  onclick={handleSubmit}
                  key={uuid()}
                  id={addButtonField.id}
                  className="card-button"
                  align={"right"}
                  disabledColored={false}
                  disabled={false}
                  field={addButtonField}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};
export default withRouter(withNamespaces()(IndividualOnboarding));
